var EHDI = EHDI || Object.create(null);

EHDI.scene = EHDI.scene || Object.create(null);

EHDI.scene.TitleScene = function() {
    EHDI.aka.Container.call(this);
    
    // DEBUG
    var DEBUG = false;
    
    var _spacebar = EHDI.interactions.Keyboard(32),
        _bgWater,
        _title = null,
        _soundButton = null,
        _coast,
        _foreground,
        _gameLogo = null,
        _bugs = null,
        _introTimeline = new TimelineMax( { autoRemoveChildren: true } );
    
    this.screenWillAppear = function() {
        _bgWater = new EHDI.aka.Sprite( EHDI.displays.TextureRectangle( 0x29C0E2, EHDI.screen.viewWidth, EHDI.screen.viewHeight ) );
        _bgWater.anchor.set(0.5, 0.5);
        this.addChild(_bgWater);
    }
    
    this.screenDidAppear = function() {
        _coast = new EHDI.aka.Sprite(EHDI.Assets.images["back_bg"]);
        _coast.anchor.set(0.5, 0.0);
        _coast.position.y = EHDI.screen.stageHeight * -0.5;
        this.addChild(_coast);
        
        _bugs = new EHDI.aka.Sprite(EHDI.Assets.images["WB_title_character"]);
        _bugs.anchor.set(0.5, 1);
        _bugs.position.set(-EHDI.screen.stageWidth * 0.065, EHDI.screen.stageHeight * 0.43);
        this.addChild(_bugs);
        
        _title = new EHDI.aka.Sprite(EHDI.Assets.images[ "WB_title_logo_" + EHDI.GAME.localeID ]);
        _title.anchor.set(0.5, 0.5);
        _title.position.set(0, -EHDI.screen.viewHeight * 0.12);
        this.addChild(_title);
        
        _foreground = new EHDI.aka.Sprite(EHDI.Assets.images["WB_title_bg_foreground"]);
        _foreground.anchor.set(0.5, 1);
        _foreground.position.set(0, EHDI.screen.stageHeight * 0.5);
        this.addChild(_foreground);
        
        var play = new EHDI.displays.Button(EHDI.Assets.images["btn_play"], null, null, null, 0.8);
        
        play.setOnClickFunction(playButtonPressed);
        
        play.position.set(0, EHDI.screen.stageHeight * 0.3);
        
        this.addChild(play);
        
        var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);
        
        _soundButton = new EHDI.displays.ToggleButton(EHDI.Assets.images["btn_audio_1"], EHDI.Assets.images["btn_audio_1"], EHDI.Assets.images["btn_audio_0-2"], EHDI.Assets.images["btn_audio_0-2"], cache.isMuted, 0.8);
        _soundButton.position.set(EHDI.screen.viewWidth * 0.425, - EHDI.screen.viewHeight * 0.375);
        this.addChild(_soundButton);
        _soundButton.setOnClickFunction(toggleAudio);
        
        if(!EHDI.GAME.debugUtils && DEBUG) {
            EHDI.GAME.debugUtils = new EHDI.debugUtils.debugUtilsContainer("v0.1.23");
            EHDI.GAME.sceneManager.addNotification(EHDI.GAME.debugUtils);
        }
        
        if(!EHDI.GAME.bgm && EHDI.screen.viewWidth > EHDI.screen.viewHeight) {
            EHDI.GAME.bgm = EHDI.GAME.soundManager.playBGM("wabbit_ingame_bgm", 0.3);
            if( cache.isMuted ) EHDI.GAME.soundManager.pauseBGM();
        }
        
        _spacebar.press = playButtonPressed;
        
        _introTimeline.from(_title, 0.5, {y: -EHDI.screen.stageHeight, ease : Back.easeOut});
    }
    
    var playButtonPressed = function() {
        _spacebar.dispose();
        EHDI.GAME.soundManager.playSFX("button_01");
        EHDI.GAME.sceneManager.changeScene(new EHDI.scene.GameScene(), {alpha : {from : 0, to : 1}, duration : 0.5}, true); 
        /*EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.ChecklistPopUp(), {alpha : {from : 0, to : 1}, duration : 0.5});*/
    }
    
    var toggleAudio = function(enable) {
        EHDI.GAME.soundManager.setMute(enable);
        var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);
        cache.isMuted = enable;
        EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.id, cache);
        EHDI.GAME.soundManager.playSFX("button_01");
    }
    
    this.onScreenResize = function() {
        _bgWater.height = EHDI.screen.viewHeight;
        _bgWater.width = EHDI.screen.viewWidth;
        
        _coast.position.y = EHDI.screen.stageHeight * -0.5;
        _bugs.position.set(-EHDI.screen.stageWidth * 0.065, EHDI.screen.stageHeight * 0.43);
        _title.position.set(0, -EHDI.screen.viewHeight * 0.12);
        _foreground.position.set(0, EHDI.screen.stageHeight * 0.5);
        _soundButton.position.set(EHDI.screen.viewWidth * 0.425, - EHDI.screen.viewHeight * 0.375);
    }
    
    this.dispose = function() {
        _introTimeline.kill();
        _introTimeline.clear();
    }
}

EHDI.scene.TitleScene.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.scene.TitleScene.prototype.destroy = function() {
    this.dispose();
    EHDI.aka.Container.prototype.destroy.apply(this, arguments);
}

